import { useCookies } from "react-cookie"
import useAppStore from "../store/AppStore"

export const useLogout = () => {
  const {setIsConnected, setAuthorizationData} = useAppStore()
  const [cookies, setCookie, removeCookie] = useCookies(['auth_data'])
  const doLogout = () => {
    removeCookie('auth_data')
    setIsConnected(false)
    setAuthorizationData(null)
  }
  return {
    doLogout,
  }
}